import React from 'react'
import * as styles from './Icon.m.css'

type IconProps = {
  icon: string
  title?: string
  text?: string
}

export const getIcon = (injectedStyles: string = null): React.FC<IconProps> => {
  return (props: IconProps): React.ReactElement => {
    const { icon, title, text } = props
    const allStyles = [styles.iconContainer, injectedStyles].join(' ')

    return (
      <span className={allStyles}>
        <div
          className={`material-symbols-outlined ${styles.icon}`}
          title={title}
        >
          {icon}
        </div>
        {text && text.length > 0 && <div className={styles.label}>{text}</div>}
      </span>
    )
  }
}
